import {
  CURRENT_ACCOUNT_INFO,
  PLANS,
  ADDONS,
  PAYMENT_INFOS,
  SAVE_CHOSEN_PLAN,
  CLEAR_CHOSEN_PLAN,
  SAVE_CHOSEN_ADDONS,
  CLEAR_CHOSEN_ADDONS
} from '@/store/actions/currentAccount.actions';

const initialState = {
  info: {},
  plans: [],
  addons: [],
  payment_infos: [],
  chosen_plan: {},
  chosen_addons: []
};

export default function currentAccount(state = initialState, action) {
  switch (action.type) {
    case CURRENT_ACCOUNT_INFO:
      return {
        ...state,
        info: action.payload.data
      };
    case PLANS:
      return {
        ...state,
        plans: action.payload.data,
        metadata: action.payload.meta
      };
    case ADDONS:
      return {
        ...state,
        addons: action.payload.data
      };
    case PAYMENT_INFOS:
      return {
        ...state,
        payment_infos: action.payload.data,
        payment_infos_meta: action.payload.meta
      };
    case SAVE_CHOSEN_PLAN:
      return {
        ...state,
        chosen_plan: action.payload
      };
    case CLEAR_CHOSEN_PLAN:
      return {
        ...state,
        chosen_plan: {}
      };
    case SAVE_CHOSEN_ADDONS:
      return {
        ...state,
        chosen_addons: action.payload
      };
    case CLEAR_CHOSEN_ADDONS:
      return {
        ...state,
        chosen_addons: []
      };
    default:
      return state;
  }
}
